import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  Footer,
  Spinner
} from '@a-ui/react';
import Favicon from 'react-favicon';
import { useDispatch } from 'react-redux';

import CardPicker from 'containers/CardPicker';
import CardOverview from 'containers/CardOverview';
import CardCharge from 'containers/CardCharge';
import AppHeader from 'components/AppHeader';
import CardActivate from 'containers/CardActivate';
import CardLink from 'containers/CardLink';
import UserContext from 'contexts/User';
import * as cardActions from './actions/card';
import { getEnvironment } from 'helpers/environment';
import { prefetchCsrfToken } from 'helpers/csrf';

import './styles/main.scss';

const STORAGE_KEY = 'sorteerpasopladen_initialLogin';

const App = () => {
  let env = getEnvironment();
  if (['local'].includes(env)) env = 'development';
  const session = React.useContext(UserContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (session.isLoggedIn) {
      prefetchCsrfToken().catch(() => {});
    }
  }, [session.isLoggedIn]);

  if (!session.isLoggedIn) return <div className="loading-container"><Spinner size="large"/></div>;

  if (localStorage.getItem(STORAGE_KEY) === 'true') {
    localStorage.setItem(STORAGE_KEY, false);

    dispatch(cardActions.getCard({
      cardNumber: '',
      cardOwnership: 'me',
    }));
  }

  return (
    <BrowserRouter>
      <Favicon url={`https://cdn.antwerpen.be/core_branding_favicons/${env !== 'prod' ? `env/${env}` : 'citizens'}/favicon-32x32.png`} />
      <AppHeader />
      <div className="u-wrapper u-bg-light">
          <div className="u-container">
            <div className="u-text-center" style={{ paddingTop: '1.5rem' }}>
              <h2>Sorteerpas beheren</h2>
              <p className="u-margin" >
                <span style={{ fontSize: '1.175rem' }}>
                  <br />
                </span>
              </p>
            </div>
          </div>
        </div>
      <div className="main u-wrapper">
        <div className="u-container u-margin-top u-margin-bottom" role="main">
        <Routes>
          <Route exact path="/" element={<CardPicker />} />
          <Route path="/activeren" element={<CardActivate />} />
          <Route path="/koppelen" element={<CardLink />} />
          <Route path="/overzicht" element={<CardOverview />} />
          <Route path="/opladen" element={<CardCharge />} />
          </Routes>
        </div>
      </div>
      <Footer items={[
        {
          label: '© stad Antwerpen'
        }
      ]}></Footer>
    </BrowserRouter>
  )
}

export default App;
